import { useEffect } from 'react';

function AdminMain() {
    
    useEffect(() => {
        console.log("test");
    }, []);
    return (
        <>
            <div>TEST</div>
        </>
    );
}
export default AdminMain;